module.exports = __webpack_public_path__ + "images/team-empty-18b8ebdf209752c1f47da5c02115ba7f.png";